import { map, getOr } from 'lodash/fp';
import { put, call } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import * as Api from '../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../helpers/saga';
import {
  fetchInventoryTags as fetchInventoryTagsRoutine,
  createInventoryTag as createInventoryTagRoutine,
  createInventoryTags as createInventoryTagsRoutine,
  deleteInventoryTag as deleteInventoryTagRoutine,
  updateInventoryTag as updateInventoryTagRoutine
} from './routines';
import { hideAddInventoryTagsModal } from '../../../actions/views/inventory/tags';

export const fetchInventoryTags = ({ payload: qs }) =>
  sagaRoutineRequest(fetchInventoryTagsRoutine, {
    request: () => call(Api.fetchInventoryTags, { qs })
  });

export const createInventoryTag = ({ payload: name }) =>
  sagaRoutineRequest(createInventoryTagRoutine, {
    request: () => call(Api.createInventoryTag, { body: { name } }),
    *success() {
      yield put(hideAddInventoryTagsModal());
      yield toastr.success('Success', `${name} tag created!`);
    },
    *failure({ error, message }) {
      const errDetails = getOr(message, '0.message', error);
      yield toastr.error(
        'Oops!',
        `Unable to create tag ${name}. ${errDetails}`
      );
    }
  });

export const createInventoryTags = ({ payload: tags }) =>
  sagaRoutineRequest(createInventoryTagsRoutine, {
    request: () => map(tag => call(createInventoryTag, { payload: tag }), tags)
  });

export const updateInventoryTag = ({ payload: { name, id } }) =>
  sagaRoutineRequest(updateInventoryTagRoutine, {
    request: () => call(Api.updateInventoryTag, { body: { name }, id }),
    *success() {
      yield toastr.success('Success', `Updated tag "${name}".`);
    }
  });

export const deleteInventoryTag = ({ payload: { name, id } }) =>
  sagaRoutineRequest(deleteInventoryTagRoutine, {
    request: () => call(Api.deleteInventoryTag, id),
    successPayload: { id },
    *success() {
      yield toastr.success('Success', `Deleted tag "${name}".`);
    }
  });
